import styled, { css } from 'styled-components';

const switchGreen = Object.freeze({
  main: '#58BD88',
  hover: '#3CA76F',
  active: '#58BD88',
});

const switchGrey = Object.freeze({
  main: 'rgba(238, 239, 239, 0.1)',
  hover: 'rgba(238, 239, 239, 0.2)',
  active: 'rgba(238, 239, 239, 0.2)',
});

export const Input = styled.input`
  display: none;
`;

export const Switch = styled.div`
  width: 16px;
  height: 16px;
  border-radius: 16px;
  transition: all 0.1s linear;

  top: 4px;
  position: absolute;
`;

const switchOn = css`
  background-color: ${switchGreen.main};

  ${Switch} {
    left: 50%;
    background-color: #eeefef;
    box-shadow: -2px 0px 4px rgba(31, 68, 49, 0.4),
      inset -2px 0px 4px rgba(0, 0, 0, 0.08);
  }

  &:hover {
    ${Switch} {
      left: 50%;
      transform: translateX(-50%);
    }
  }
`;

const switchOff = css`
  background-color: ${switchGrey.main};

  ${Switch} {
    left: 4px;
    background-color: #676969;
    box-shadow: 2px 0px 4px rgba(0, 0, 0, 0.32),
      inset -2px 0px 4px rgba(0, 0, 0, 0.08);
  }

  &:hover {
    background-color: ${switchGrey.hover};
    ${Switch} {
      left: 50%;
      transform: translateX(-50%);
    }
  }
`;

type ContainerProps = { value: boolean };

export const SwitchContainer = styled.div<ContainerProps>`
  width: 40px;
  height: 24px;
  cursor: pointer;
  user-select: none;
  flex-shrink: 0;
  position: relative;
  border-radius: 18px;

  ${({ value }) => css`
    ${value ? switchOn : switchOff}
  `}
`;
